<template>
    <v-dialog v-model="dialog" persistent max-width="550">
        <template v-slot:activator="{ props }">
            <v-btn rounded color="orange" class="text-white" v-bind="props">{{ $t('checkIn.break') }}</v-btn>
        </template>
        <v-card>
            <v-form ref="form"
                    v-model="valid">
                <v-card-title class="headline">{{ $t('checkIn.new_break') }}</v-card-title>
                <v-divider class="vdivider"></v-divider>
                <div class="dialog_middle">
                    <div class="subheading">{{ $t('checkIn.time') }}</div>
                    <v-btn-toggle
                            v-model="pauseModel.pause_time"
                            mandatory
                            required
                            variant="outlined"
                            color="orange"
                            >
                        <v-btn v-for="(time, idx) in times" :key="idx" :value="time.value">
                            {{time.text}}
                        </v-btn>
                    </v-btn-toggle>


                    <div class="textarea">
                        <span class="subheading">{{ $t('checkIn.message') }}</span>
                        <v-textarea
                                :auto-grow="false"
                                :counter="150"
                                variant="solo"
                                no-resize
                                v-model="pauseModel.text_area"
                                @keydown="limit( $event, pauseModel.text_area, 150)"
                                solo></v-textarea>
                    </div>
                </div>

                <v-divider class="vdivider"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey lighten-5" class="button_text" rounded @click="cancelButton">{{ $t('checkIn.close') }}</v-btn>
                    <v-btn color="orange" :disabled="!valid" rounded @click="startPause()">{{
                        $t('checkIn.start') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import { post } from '@/services/api'
    import moment from 'moment';
    import eventBus from "@/services/study-department/eventBus";

    export default {
        name: "PauseDialog",

        data() {
            return {
                dialog: false,

                pauseModel: {
                    pause_time: "5",
                    text_area: '',
                },

                valid: true,
                form: null,

                times: [{"text": this.$t('headers.five_min'), "value": "5"},
                    {"text": this.$t('headers.ten_min'), "value": "10"},
                    {"text": this.$t('headers.fifteen_min'), "value": "15"},
                ]
            }
        },

        computed: {
            ...mapGetters('pageStorage', ['getAssistantIdStorage']),
        },


        methods: {
        ...mapActions('AssistantPause', ['setActivePauseStorage']),

            limit(event, dataProp, limit) {
                if (dataProp.length >= limit) {
                    if (event.keyCode.toString() === '8' || event.keyCode.toString() === '46') {
                        null
                    } else {
                        event.preventDefault();
                    }
                }
            },

            startPause: function () {
                this.addNewPauseToBackend();
            },

            cancelButton() {
                this.dialog = false;
                this.resetModel();
            },

            endButton() {
                if (confirm(this.$t('checkIn.checkIn_confirm'))) {
                    this.dialog = false;
                    eventBus.$emit('callInStart');
                    this.resetModel();
                }
            },

            resetModel() {
                this.pauseModel.pause_time = null;
                this.pauseModel.text_area = '';
            },

            addNewPauseToBackend() {
                post('study_department/assistant/pause/', {
                    "assistantId": this.getAssistantIdStorage,
                    "date": moment().format("YYYY-MM-DD"),
                    "duration": this.pauseModel.pause_time,
                    "note": this.pauseModel.text_area,
                    "startTime": moment().format("HH:mm:ss"),
                    "status": "active"
                }).then((response) => {
                    this.setActivePauseStorage(response.data.content);
                    this.dialog = false;
                    eventBus.$emit('callInPauseStarted');
                    this.resetModel();
                }).catch(e => alert(e.message));
            }
        }
    }
</script>

<style scoped>

    .vdivider {
        margin-top: 0 !important;
    }

    .dialog_middle {
        padding: 0 1rem 0 1rem;
    }

    .time_group {
        display: inline-flex;
    }

    .button_float_left {
        float: left !important;
        text-transform: capitalize;
        width: 30%;
    }

    .textarea {
        width: 100%;
        padding-top: 1rem;
    }

</style>
